import { render } from "./viewClientComponent.vue?vue&type=template&id=ee231b70&scoped=true"
import script from "./viewClientComponent.vue?vue&type=script&lang=js"
export * from "./viewClientComponent.vue?vue&type=script&lang=js"

import "./viewClientComponent.vue?vue&type=style&index=0&id=ee231b70&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee231b70"]])

export default __exports__